import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import request from "../../../Helpers/API";
import { LoaderScreen } from "../../components/LoaderScreen";


export const TablaResumenDetalle = ({
    data,
    arrayMes,
    titulo,
    totales
}) => {
    const history = useHistory();
    const [detalle, setDetalle] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [selectedFolio, setSelectedFolio] = useState(null);


    const capitalizeWords = (str) => {
        if (!str) return ''; // Manejar casos de texto vacío
        return str
            .toLowerCase() // Convertir todo a minúsculas
            .split(' ') // Dividir la cadena en palabras
            .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalizar la primera letra de cada palabra
            .join(' '); // Unir las palabras de nuevo en una cadena
    };

    const ShowTd = (folio) => {
        if (selectedFolio === folio) {
            setSelectedFolio(null); // Si el folio ya está seleccionado, deselecciona
            setDetalle([]); // Limpia el detalle
        } else {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `CumplimientoCondicionadas/ObtenerDetalleFolio?folio=${folio}`
                )
                .then((result) => {
                    console.log(result)
                    setSelectedFolio(folio);
                    setLoader({ ...loader, mostrar: false });
                    setDetalle(result);
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                });
        }
    };

    return (
        <div className="cumplimiento-documentacion-credito-condicionados-detalle-container-table-scroll scroll-4">
            <LoaderScreen loader={loader} />
            <table cellPadding={0} cellSpacing={0} className="table-detalle">
                <thead className="thead">
                    <tr>
                        <th>Cliente</th>
                        <th>Vendedor</th>
                        <th>Solicitados</th>
                        {/* <th>Abiertas</th> */}
                        <th>Entregados</th>
                        <th>%</th>
                        <th>Faltantes</th>
                        <th>%</th>
                        <th>Puntuales</th>
                        <th>%</th>
                        <th>Retrasados</th>
                        <th>%</th>
                        <th>Vencido</th>
                    </tr>
                </thead>
                <tbody className="tbody">
                    {arrayMes.map((mes, index) => (
                        <>
                            <tr>
                                <td colSpan={12} className="header-mes">
                                    {mes.toUpperCase()}
                                </td>
                            </tr>
                            {data.filter(a => a.mes === mes).map((item, index) => (
                                <>
                                    <tr
                                        className="ver-detalle-folio"
                                        onClick={() => ShowTd(item.folio)}
                                    >
                                        <td className="borde-vertical">
                                            {capitalizeWords(item.razon_social)}
                                        </td>
                                        <td className="borde-vertical">
                                            {item.vendedor}
                                        </td>
                                        <td className="borde-vertical alinear-centro">
                                            {item.documentos_solicitados}
                                        </td>
                                        <td className="borde-vertical alinear-centro">
                                            {item.documentos_entregados}
                                        </td>
                                        <td className="borde-vertical alinear-derecha">
                                            {item.porcentaje_documentos_entregados + "%"}
                                        </td>
                                        <td className="borde-vertical alinear-centro">
                                            {item.documentos_faltantes}
                                        </td>
                                        <td className="borde-vertical alinear-derecha">
                                            {item.porcentaje_documentos_faltantes + "%"}
                                        </td>
                                        <td className="borde-vertical alinear-centro">
                                            {item.documentos_puntuales}
                                        </td>
                                        <td className="borde-vertical alinear-derecha">
                                            {item.porcentaje_documentos_puntuales + "%"}
                                        </td>
                                        <td className="borde-vertical alinear-centro">
                                            {item.documentos_retrasados}
                                        </td>
                                        <td className="borde-vertical alinear-derecha">
                                            {item.porcentaje_documentos_retrasados + "%"}
                                        </td>
                                        <td className="borde-vertical alinear-centro">
                                            {item.dias_vencido === -1 ? "-" : item.dias_vencido}
                                        </td>
                                    </tr>

                                    {selectedFolio === item.folio && ( // Solo muestra el detalle si el folio coincide
                                        <tr className="row-sucursales-detalle ">
                                            <td colSpan={12} className="td-sucursales-detalle">
                                                <div className="row-sucursales-table">
                                                    <table cellPadding={0} cellSpacing={0}>
                                                        <thead>
                                                            <tr>
                                                                <th>Documento</th>
                                                                <th>Solicitud</th>
                                                                <th>Compromiso</th>
                                                                <th>Entregado</th>
                                                                <th>Vencido</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {detalle.map((det) => (
                                                                <tr key={det.documento}>
                                                                    <td>{det.documento}</td>
                                                                    <td>{det.fecha_solicitud}</td>
                                                                    <td>{det.fecha_compromiso}</td>
                                                                    <td>{det.fecha_entregado}</td>
                                                                    <td>{det.dias_vencido < 0 ? "-" : det.dias_vencido}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </>
                            ))}
                            {totales.filter(a => a.mes === mes).map((total, index) => (
                                <tr className="totales-por-mes">
                                    <td></td>
                                    <td className="letras-negras alinear-centro">TOTAL</td>
                                    <td className="alinear-centro">
                                        {total.total_solicitados}
                                    </td>
                                    <td className="alinear-centro">
                                        {total.total_documentos_entregados}
                                    </td>
                                    <td>
                                        {total.total_porcentaje_documentos_entregados + "%"}
                                    </td>
                                    <td className="alinear-centro">
                                        {total.total_documentos_faltantes}
                                    </td>
                                    <td>
                                        {total.total_porcentaje_documentos_faltantes + "%"}
                                    </td>
                                    <td className="alinear-centro">
                                        {total.total_documentos_puntuales}
                                    </td>
                                    <td>
                                        {total.total_porcentaje_documentos_puntuales + "%"}
                                    </td>
                                    <td className="alinear-centro">
                                        {total.total_documentos_retrasados}
                                    </td>
                                    <td>
                                        {total.total_porcentaje_documentos_retrasados}
                                    </td>
                                    <td className="alinear-centro">
                                        {total.total_dias_vencido}
                                    </td>
                                </tr>
                            ))}
                        </>
                    ))}

                    <tr className="row-totales-operaciones">
                        <td></td>
                        <td>TOTAL</td>
                        <td className="alinear-centro">
                            {data.reduce(
                                (acumulador, item) => acumulador + item.documentos_solicitados,
                                0
                            )}
                        </td>
                        <td className="alinear-centro">
                            {data.reduce((acumulador, item) => acumulador + item.documentos_entregados, 0)}
                        </td>
                        <td>
                            {data.length > 0
                                ? (data.reduce((acumulador, item) => acumulador + item.porcentaje_documentos_entregados, 0) / data.length).toFixed(2) + "%"
                                : '0%'}
                        </td>
                        <td className="alinear-centro">
                            {data.reduce(
                                (acumulador, item) => acumulador + item.documentos_faltantes,
                                0
                            )}
                        </td>
                        <td>
                            {data.length > 0
                                ? (data.reduce((acumulador, item) => acumulador + item.porcentaje_documentos_faltantes, 0) / data.length).toFixed(2) + "%"
                                : '0%'}
                        </td>
                        <td className="alinear-centro">
                            {data.reduce(
                                (acumulador, item) => acumulador + item.documentos_puntuales,
                                0
                            )}
                        </td>
                        <td>
                            {data.length > 0
                                ? (data.reduce((acumulador, item) => acumulador + item.porcentaje_documentos_puntuales, 0) / data.length).toFixed(2) + "%"
                                : '0%'}
                        </td>
                        <td className="alinear-centro">
                            {data.reduce((acumulador, item) => acumulador + item.documentos_retrasados, 0)}
                        </td>
                        <td>
                            {data.length > 0
                                ? (data.reduce((acumulador, item) => acumulador + item.porcentaje_documentos_retrasados, 0) / data.length).toFixed(2) + "%"
                                : '0%'}
                        </td>
                        <td>
                            {data.length > 0
                                ? data.reduce((maxItem, item) => (item.dias_vencido > maxItem.dias_vencido ? item : maxItem), data[0]).fecha_vencido
                                : '-'}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
